new Vue({
    el: '#ethic',
    data: {
        fullname: null,
        personalId: null,
        phone: null,
        address: null,
        email: null,
        accessToFullname: null,
        accessToContactInfo: null,
        employeeFullname: null,
        employeePosition: null,
        message: null,
        files: [],


        answers: [],


        intro: null,
        terms: null,
        secondBlock: null,
        thirdBlock: null,

        isSubmited: false,
        result: false,
        resultMessage: null,
        sendingData: false,

        agreeTerms: false,
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    },
    methods: {
        send: function (e) {
            e.preventDefault();
            var _this = this;
            if (_this.sendingData) { return; }
            _this.isSubmited = true;
            _this.resultMessage = null;
            valid = true;

            var formData = new FormData();
            formData.append('fullname', _this.fullname);
            formData.append('personalId', _this.personalId);
            formData.append('phone', _this.phone);
            formData.append('address', _this.address);
            formData.append('email', _this.email);
            formData.append('accessToFullname', _this.accessToFullname['title']);
            formData.append('accessToContactInfo', _this.accessToContactInfo['title']);
            formData.append('employeeFullname', _this.employeeFullname);
            formData.append('employeePosition', _this.employeePosition);
            formData.append('message', _this.message);
            formData.append('captchaVal', $("#g-recaptcha-response").val());
      
            for (var i = 0; i < _this.files.length; i++) {
                let file = _this.files[i].file;

                formData.append('files[' + i + ']', file);
            }

            formData.append('languageId', window.languageId);

            var headerData = {
                headers: {
                    'content-type':'multipart/form-data'
                }
            };

            if (!_this.fullname ||
                !_this.personalId ||
                !_this.phone ||
                !_this.address ||
                !_this.email ||
                !_this.employeeFullname ||
                !_this.employeePosition ||
                !_this.message ||
                !_this.agreeTerms ||
                _this.personalId.length != 11 ||
                !_this.reg.test(_this.email)) {
                valid = false;
            }
            if (valid) {
                _this.sendingData = true;
                axios.post('~/api/ethic/send', formData, headerData).then(function (response) {
                    _this.result = response.data.success;
                    _this.resultMessage = response.data.message;
                }).catch(function (e) {
                    _this.result = false;
                    _this.resultMessage = window.errorPhrase;
                }).finally(function (e) {
                    _this.sendingData = false;
                })
            }
            _this.isSubmited = true;

            return false;
        }
    },
    mounted: function () {
        var _this = this;
        if (!!window.ethicFormSettings) {
            _this.answers = window.ethicFormSettings.answers;
            _this.intro = window.ethicFormSettings.intro;
            _this.terms = window.ethicFormSettings.terms;
            _this.secondBlock = window.ethicFormSettings.secondBlock;
            _this.thirdBlock = window.ethicFormSettings.thirdBlock;
            _this.accessToFullname = _this.answers[0];
            _this.accessToContactInfo = _this.answers[0];
        }
    }
})